import classNames from "classnames";
import Dropdown from "../Elements/Dropdown";
import PropTypes from "prop-types";

const CardMobile = ({
  title,
  onClick,
  children,
  className = "",
  dropdownOptions,
  contentBgColor,
}) => {
  return (
    <div
      className={classNames(
        "flex relative flex-col items-start bg-white card-base-border rounded-md p-4 h-full w-full gap-2",
        className
      )}
      onClick={onClick}
      tabIndex={0}
      role="button"
      style={{ touchAction: "manipulation" }}
    >
      {/* Dropdown icon in top-right */}
      {dropdownOptions && (
        <div className="absolute top-2 right-2 z-10">
          <Dropdown options={dropdownOptions} rotateOnOpen={false} />
        </div>
      )}
      {/* Title in blue box */}
      {title && (
        <div className="mb-2 text-sm font-semibold text-white flex items-center justify-center px-3 py-2 rounded-md bg-blue-800">
          {title}
        </div>
      )}

      {/* Children (optional extra content) */}
      <div
        className={classNames(
          "w-full flex flex-col justify-center items-center rounded-md",
          contentBgColor
        )}
      >
        {children}
      </div>
    </div>
  );
};

CardMobile.propTypes = {
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  children: PropTypes.node,
  className: PropTypes.string,
  dropdownOptions: PropTypes.array,
  contentBgColor: PropTypes.string,
};

export default CardMobile;
